/* istanbul ignore file */

// exclude this file from jest coverage as it doesn't contain business logic
export const PRICE_DISPLAY = {
  hidePrices: 'hide',
  purchasePrices: 'purchase',
  retailPrices: 'recommended' // AKA CAP-modus
}
